import { useQuery } from "@tanstack/react-query";
import resumeRepositoryService from "../services/resumeRepositoryService";
import { buildResumeSearchParams } from "../utils/queryBuilder";

export const RESUME_QUERY_KEYS = {
  search: "resumeRepository.search",
  detail: "resumeRepository.detail",
  versions: "resumeRepository.versions",
  talentPools: "resumeRepository.talentPools",
  match: "resumeRepository.match",
};

const useResumeSearch = (filters) => {
  const params = buildResumeSearchParams(filters);

  return useQuery({
    queryKey: [RESUME_QUERY_KEYS.search, params],
    queryFn: () => resumeRepositoryService.searchResumes(params),
    keepPreviousData: true,
  });
};

export default useResumeSearch;
